/*!
 * devextreme-angular
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { ValueErrorBarDisplayMode, ValueErrorBarType } from 'devextreme/common/charts';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-chart-value-error-bar',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoChartValueErrorBarComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get color(): string {
        return this._getOption('color');
    }
    set color(value: string) {
        this._setOption('color', value);
    }

    @Input()
    get displayMode(): ValueErrorBarDisplayMode {
        return this._getOption('displayMode');
    }
    set displayMode(value: ValueErrorBarDisplayMode) {
        this._setOption('displayMode', value);
    }

    @Input()
    get edgeLength(): number {
        return this._getOption('edgeLength');
    }
    set edgeLength(value: number) {
        this._setOption('edgeLength', value);
    }

    @Input()
    get highValueField(): string | undefined {
        return this._getOption('highValueField');
    }
    set highValueField(value: string | undefined) {
        this._setOption('highValueField', value);
    }

    @Input()
    get lineWidth(): number {
        return this._getOption('lineWidth');
    }
    set lineWidth(value: number) {
        this._setOption('lineWidth', value);
    }

    @Input()
    get lowValueField(): string | undefined {
        return this._getOption('lowValueField');
    }
    set lowValueField(value: string | undefined) {
        this._setOption('lowValueField', value);
    }

    @Input()
    get opacity(): number | undefined {
        return this._getOption('opacity');
    }
    set opacity(value: number | undefined) {
        this._setOption('opacity', value);
    }

    @Input()
    get type(): undefined | ValueErrorBarType {
        return this._getOption('type');
    }
    set type(value: undefined | ValueErrorBarType) {
        this._setOption('type', value);
    }

    @Input()
    get value(): number {
        return this._getOption('value');
    }
    set value(value: number) {
        this._setOption('value', value);
    }


    protected get _optionPath() {
        return 'valueErrorBar';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoChartValueErrorBarComponent
  ],
  exports: [
    DxoChartValueErrorBarComponent
  ],
})
export class DxoChartValueErrorBarModule { }
